import { Container, Stack, styled } from '@mui/material';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Components
import BreadcrumbWithBtnBack from 'src/components/BreadcrumbWithBtnBack';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';
import Buyer from 'src/features/BillOfLadingDetail/Buyer';
import TradeDataInformation from 'src/features/BillOfLadingDetail/Common/Information';
import Description from 'src/features/BillOfLadingDetail/Description';
import ExchangeRate from 'src/features/BillOfLadingDetail/ExchangeRate';
import MapAddress from 'src/features/BillOfLadingDetail/MapAddress';
import NotifyParty from 'src/features/BillOfLadingDetail/NotifyParty';
import PackingInformation from 'src/features/BillOfLadingDetail/PackingInformation';
import Port from 'src/features/BillOfLadingDetail/Port';
import ProductBrand from 'src/features/BillOfLadingDetail/ProductBrand';
import Shipper from 'src/features/BillOfLadingDetail/Shipper';
import SkeletonBolDetail from 'src/features/BillOfLadingDetail/SkeletonBolDetail';
import Supplier from 'src/features/BillOfLadingDetail/Supplier';

// Utilities
import { useQueryBillOfLadingDetail } from 'src/services/queries/useQueryTradeData';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(7),
  marginTop: theme.spacing(1),
  textAlign: 'center',
}));

const BillOfLadingDetail = () => {
  const { id } = useParams();
  const { data, isFetching } = useQueryBillOfLadingDetail(id || '');
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate(AuthRouteKeys.Home);
    }
  }, []);

  if (isFetching) {
    return (
      <StyledContainer maxWidth="xl">
        <SkeletonBolDetail />
      </StyledContainer>
    );
  }

  return (
    <StyledContainer maxWidth="xl">
      <Stack py={3} spacing={3}>
        <BreadcrumbWithBtnBack
          listItem={[
            {
              text: 'Trade Data',
            },
            {
              text: String(renderTextOrDefault(data?.data?.transaction?.hs_code)),
            },
            {
              text: data?.data?.transaction?.bol || '',
            },
          ]}
          updatedAt={data?.data?.transaction?.updated_at || ''}
        />

        <SectionErrorBoundary resetKey="BillOfLadingDetail" sectionName="BillOfLadingDetail">
          <TradeDataInformation tradeDataDetail={data?.data} />
          <Description tradeDataDetail={data?.data} />
          {!isEmpty(data?.data?.transaction?.product_brand_name) && <ProductBrand tradeDataDetail={data?.data} />}
          {!isEmpty(data?.data?.buyer) && <Buyer tradeDataDetail={data?.data} />}
          {!isEmpty(data?.data?.supplier) && <Supplier tradeDataDetail={data?.data} />}
          {!isEmpty(data?.data?.transaction?.notify_party_name) && <NotifyParty tradeDataDetail={data?.data} />}
          {!isEmpty(data?.data?.transaction?.vessel_name) && <Shipper tradeDataDetail={data?.data} />}
          {!isEmpty(data?.data?.transaction?.exchange_currency) && <ExchangeRate tradeDataDetail={data?.data} />}
          <PackingInformation tradeDataDetail={data?.data} />
          <Port tradeDataDetail={data?.data} />
          <MapAddress tradeDataDetail={data?.data} />
        </SectionErrorBoundary>
      </Stack>
    </StyledContainer>
  );
};

export default BillOfLadingDetail;
